import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReviewsComponent from "./ReviewsComponent";
import LandingPageComponent from "./LandingPageComponent";
import LicensePageComponent from "./LicensePageComponent";


function App() {
  return (
    <div className="appContainer">
      <BrowserRouter>
        <Routes>
          <Route path="/" Component={LandingPageComponent}>
          </Route>
          <Route path="/reviews" Component={ReviewsComponent}>
          </Route>
          <Route path="/license" Component={LicensePageComponent}>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
